import {Component, Input} from '@angular/core';
import {OrganizationSelectors} from '@store/store.selectors';

@Component({
  selector: 'rn-registration-complete',
  template: `
    <div class="flex-row flex-start-center mobile-centered">
      <div class="registration-form">
        <div class="mat-headline-3 registration-title">Success!</div>
        @let copy = organizationSelectors.copyOverrides | select;
        @let customMessage = forLookupContext ? undefined: copy?.REGISTRATION_CONFIRMATION_MESSAGE;
        <h4 class="registration-description">
          @if (customMessage) {
            <span class="custom-message">{{ customMessage }}</span>
          } @else {
            Welcome to {{ organizationSelectors.name | select }}. You now have full access to digital resources as well as our
            extensive collection of books, DVDs, CDs and more!
          }
          <br/><br/>
          What would you like to do first?</h4>
        <a mat-raised-button color="primary" class="next-button browse-button" routerLink="/catalog">Browse Catalog</a>
        <a mat-raised-button class="next-button view-account-button" routerLink="/profile#account">View Account</a>
      </div>
    </div>
  `,
  styleUrl: './registration-complete.component.scss',
  standalone: false
})
export class RegistrationCompleteComponent {
  @Input() forLookupContext = false;
  public readonly organizationSelectors = OrganizationSelectors.Auth;
}
